// Centralized feature-gating based on available credits.
// Add or modify thresholds here to affect gating app-wide.

export const CREDIT_THRESHOLDS = {
  premiumMode: 41,     // credits < 41 disables Premium mode
  video720p: 48,       // credits < 48 disables 720p
  video1080p: 126,     // credits <= 126 disables 1080p
};

export function normalizeCredits(rawValue) {
  const n = Number(rawValue);
  if (!Number.isFinite(n)) return 0;
  return n;
}

export function buildFeatureGates(credits) {
  const c = normalizeCredits(credits);
  return {
    // Modes
    disablePremium: c < CREDIT_THRESHOLDS.premiumMode,

    // Video resolutions
    disable720p: c < CREDIT_THRESHOLDS.video720p,
    disable1080p: c <= CREDIT_THRESHOLDS.video1080p,
  };
}

export function applyAutoDowngrade({ resolution, mode }, gates) {
  let nextResolution = resolution;
  let nextMode = mode;

  // Auto-downgrade resolution using gating
  if (nextResolution === '1080p' && gates.disable1080p) {
    nextResolution = gates.disable720p ? '480p' : '720p';
  }
  if (nextResolution === '720p' && gates.disable720p) {
    nextResolution = '480p';
  }

  // Auto-downgrade mode using gating
  if (nextMode === 'pro_max' && gates.disablePremium) {
    nextMode = 'pro';
  }

  return { resolution: nextResolution, mode: nextMode };
}


